import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import routes from 'app/store/reducers/fuse/routes.reducer';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import pagesConfigs from '../../../app/main/pages/pagesConfigs';
import allPagesConfig from '../../../app/main/pages/allPagesConfig';
import { HOME_URL, HOME_URL2 } from './../../../app/common/parameters.js';

class FuseAuthorization extends Component {
	constructor(props, context) {
		super(props);
		const { routes } = context;
		this.state = {
			accessGranted: true,
			routes,
			user_routes: null
		};
	}

	componentDidMount() {
		if (this.props.hasPermission === null) {
			this.redirectRoute();
		} else {
			this.setState({ user_routes: this.props.hasPermission });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return nextState.accessGranted !== this.state.accessGranted;
	}

	componentDidUpdate() {
		if (!this.state.accessGranted) {
			this.redirectRoute();
		}
	}
	static pageExists(pathname) {
		if (allPagesConfig && allPagesConfig.length) {
			let data = allPagesConfig.map(config => {
				if (config && config.routes && config.routes.length) {
					return [
						...config.routes.map(route => {
							if (route && route.path && route.path === pathname) {
								return true;
							}
						})
					];
				}
			});
			data = [].concat(...data);
			if (data && data.length) {
				data = data.filter(el => el === true);
				if (data && data.length) {
					return true;
				}
			}
		}

		return false;
	}
	static findPath(pathname) {
		if (pagesConfigs && pagesConfigs.length) {
			let data = pagesConfigs.map(config => {
				if (config && config.routes && config.routes.length) {
					return [
						...config.routes.map(route => {
							if (route && route.path && route.path === pathname) {
								return true;
							}
						})
					];
				}
			});
			data = [].concat(...data);
			if (data && data.length) {
				data = data.filter(el => el === true);
				if (data && data.length) {
					return true;
				}
			}
		}
		return false;
	}

	static getDerivedStateFromProps(props, state) {
		const { location, userRole } = props;
		const { pathname } = location;

		let check = FuseAuthorization.findPath(pathname);
		if (check) {
			let userAcl = localStorage.getItem('user_acl');
			if(userAcl) {
				userAcl = JSON.parse(userAcl);
				if (!userAcl[`FRONT:${pathname}`]) {
					if (window.location.pathname !== HOME_URL && userAcl[`FRONT:${HOME_URL}`]) {
						window.location = HOME_URL;
					} else if (window.location.pathname !== HOME_URL2 && userAcl[`FRONT:${HOME_URL2}`]) {
						window.location = HOME_URL2;
					} else {
						window.location = '/';
					}
				}
			}
			return {
				accessGranted: check
			};
		} else {
			let userAcl = localStorage.getItem('user_acl');
			let pageExists = FuseAuthorization.pageExists(pathname);
			if (pageExists) {
				if (userAcl) {
					FuseAuthorization.redirectUser(userAcl)
				} else {
					if (window.location.pathname !== '/login') {
						window.location = '/login';
					}
				}
			} else {
				if (userAcl) {
					FuseAuthorization.redirectUser(userAcl)
				} else {
					if (window.location.pathname === '/') {
						window.location = '/login';
					} else if (window.location.pathname !== '/pagenotfound') {
						window.location = '/pagenotfound';
					}
				}
			}

			return {
				accessGranted: false
			};
		}
	}

	static redirectUser (userAcl) {
		userAcl = JSON.parse(userAcl);
		if (window.location.pathname !== HOME_URL && userAcl[`FRONT:${HOME_URL}`]) {
			window.location = HOME_URL;
		} else if (window.location.pathname !== HOME_URL2 && userAcl[`FRONT:${HOME_URL2}`]) {
			window.location = HOME_URL2;
		} else {
			window.location = '/';
		}

		return true;
	}

	redirectRoute() {
	}

	render() {
		return this.state.accessGranted ? <>{this.props.children}</> : null;
	}
}

function mapStateToProps({ auth }) {
	return {
		userRole: auth.user.role
	};
}

FuseAuthorization.contextType = AppContext;

export default withRouter(connect(mapStateToProps)(FuseAuthorization));
